__turbopack_context__.v({
  "audioControls": "_12BHWq_audioControls",
  "audioElement": "_12BHWq_audioElement",
  "audioPlayer": "_12BHWq_audioPlayer",
  "backControls": "_12BHWq_backControls",
  "body": "_12BHWq_body",
  "controlsWrapper": "_12BHWq_controlsWrapper",
  "coverImage": "_12BHWq_coverImage",
  "currentTime": "_12BHWq_currentTime",
  "ergonomic": "_12BHWq_ergonomic",
  "forwardControls": "_12BHWq_forwardControls",
  "headings": "_12BHWq_headings",
  "imageSection": "_12BHWq_imageSection",
  "imageWrapper": "_12BHWq_imageWrapper",
  "isActive": "_12BHWq_isActive",
  "isPlaying": "_12BHWq_isPlaying",
  "mediaSection": "_12BHWq_mediaSection",
  "micro-player": "_12BHWq_micro-player",
  "mini-player": "_12BHWq_mini-player",
  "pauseIcon": "_12BHWq_pauseIcon",
  "play": "_12BHWq_play",
  "playIcon": "_12BHWq_playIcon",
  "playWrapper": "_12BHWq_playWrapper",
  "playlist": "_12BHWq_playlist",
  "playlistTitle": "_12BHWq_playlistTitle",
  "playlistTrack": "_12BHWq_playlistTrack",
  "playlistTrackThumbnail": "_12BHWq_playlistTrackThumbnail",
  "playlistTrackTitle": "_12BHWq_playlistTrackTitle",
  "progressBar": "_12BHWq_progressBar",
  "remainingTime": "_12BHWq_remainingTime",
  "scrubberWrapper": "_12BHWq_scrubberWrapper",
  "seekBack": "_12BHWq_seekBack",
  "seekForward": "_12BHWq_seekForward",
  "subtitle": "_12BHWq_subtitle",
  "timeButtons": "_12BHWq_timeButtons",
  "timeControls": "_12BHWq_timeControls",
  "title": "_12BHWq_title",
  "transcript": "_12BHWq_transcript",
  "transcriptFalse": "_12BHWq_transcriptFalse",
  "transcriptIsOpen": "_12BHWq_transcriptIsOpen",
  "transcriptSection": "_12BHWq_transcriptSection",
  "transcriptToggle": "_12BHWq_transcriptToggle",
  "transcriptToggleIcon": "_12BHWq_transcriptToggleIcon",
  "transcriptToggleText": "_12BHWq_transcriptToggleText",
  "transcriptTrue": "_12BHWq_transcriptTrue",
  "transcriptWrapper": "_12BHWq_transcriptWrapper",
});
